import { useEffect, useMemo } from 'react';
import { useQuoteStore } from '../stores/quoteStore';

export const useQuoteRequests = () => {
  const {
    quoteRequests,
    allianceQuoteRequests,
    fetchQuoteRequests,
    fetchAllianceQuoteRequests,
    quoteRequestsLoading,
  } = useQuoteStore();

  useEffect(() => {
    fetchQuoteRequests();
    fetchAllianceQuoteRequests();
  }, [fetchAllianceQuoteRequests, fetchQuoteRequests]);

  const pendingQuoteRequests = useMemo(
    () => quoteRequests.filter(qr => qr.status === 'pending' && qr.job.status === 'open'),
    [quoteRequests]
  );

  const pendingAllianceQuotes = useMemo(
    () => allianceQuoteRequests.filter(q => q.status === 'pending'),
    [allianceQuoteRequests]
  );

  const unquotedQuoteRequests = useMemo(
    () => quoteRequests.filter(qr => qr.status === 'accepted' && !qr.has_quote),
    [quoteRequests]
  );

  const unquotedAllianceQuoteRequests = useMemo(
    () => allianceQuoteRequests.filter(aqr => aqr.status === 'accepted' && !aqr.has_quote),
    [allianceQuoteRequests]
  );

  const allUnquotedQuoteRequests = [...unquotedQuoteRequests, ...unquotedAllianceQuoteRequests];
  const allPendingQuoteRequests = [...pendingQuoteRequests, ...pendingAllianceQuotes];

  return {
    quoteRequests,
    allPendingQuoteRequests,
    unquotedQuoteRequests,
    unquotedAllianceQuoteRequests,
    allUnquotedQuoteRequests,
    loading: quoteRequestsLoading,
    // Helper function to get mixed array for components that can handle it
    getMixedUnquotedRequests: () => allUnquotedQuoteRequests,
  };
};
